import { render, staticRenderFns } from "./alertDelete.vue?vue&type=template&id=b32db274"
import script from "./alertDelete.vue?vue&type=script&lang=js"
export * from "./alertDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports